export var getChatWidgetNode = function getChatWidgetNode() {
  var _document;
  var node = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector('[data-portal-type="widgetChat"]');
  return node ? node : undefined;
};